<div class="validation-container">
  <rask-virkeskop-validation-message
    entityType="skogsvardsatgardforyngring"
    [entityGuid]="skogsvardsAtgard.guid">
  </rask-virkeskop-validation-message>
</div>
<div class="row">
  @if (skogsvardTradslagLista) {
    <div>
      @if (skogsvardTradslagLista?.length > 0) {
        <div>
          @for (skogsvardTradslag of skogsvardTradslagLista; track skogsvardTradslag; let i = $index) {
            <div>
              <rask-skogsvard-foryngring-tradslag
                [skogsvardTradslagLista]="skogsvardTradslagLista"
                [kontraktReadonly]="kontraktReadonly"
                (deleted)="deleted($event)"
                [index]="i"
                [skogsvardTradslag]="skogsvardTradslag"
                [allatradslag]="allatradslag"
                [skogsvardsAtgard]="skogsvardsAtgard">
              </rask-skogsvard-foryngring-tradslag>
            </div>
          }
        </div>
      }
    </div>
  }

  <div class="col-12">
    <div class="pb-2 pt-4">
      <rask-action-button icon="fas fa-plus" [disabled]="kontraktReadonly || skogsvardsAtgard.isReadonly" (click)="addRow()" class="float-start">Lägg till trädslag</rask-action-button>
    </div>
  </div>
</div>